import PropTypes from 'prop-types';
import React, { Component } from 'react';

import '../css/uploadButton.css';

import { uploadImageAndGetUrl, uploadImageAndGetSize } from '../util/url';

export default class UploadButton extends Component {
    state = {
        uploading: false,
    }

    onUpload = (e) => {
        const { onUpload, getSize } = this.props;
        const file = e.target.files[0];
        e.target.value = '';
        if (!file) {
            return;
        }
        if (!file.type.match(/image\/(jpeg|png|bmp)/)) {
            console.error('Must choose an image to upload'); // eslint-disable-line no-console
        }
        this.setState({ uploading: true });
        const upload = getSize ? uploadImageAndGetSize : uploadImageAndGetUrl;
        upload(file)
            .then(onUpload)
            .catch(() => {})
            .then(() => this.setState({ uploading: false }));
        e.target.value = '';
    }

    render() {
        const { className, buttonType, label } = this.props;
        const { uploading } = this.state;
        const type = buttonType || 'default';
        return (
            <button
                disabled={uploading}
                className={`upload-button btn btn-${type} ${className}${uploading ? ' upload-button--uploading' : ''}`}
            >
                <div className='upload-button__label'>{label}</div>
                <img className='spinner upload-button__spinner' src='https://static.mex.cimpress.io/mcp-ux-css/latest/assets/spinner.svg' alt='loading' />
                <input
                    className='upload-button__input'
                    type='file'
                    onChange={this.onUpload}
                    disabled={uploading}
                    accept='image/png, image/jpeg, image/bmp'
                />
            </button>
        );
    }
}

UploadButton.propTypes = {
    label: PropTypes.string.isRequired,
    className: PropTypes.string,
    buttonType: PropTypes.string,
    onUpload: PropTypes.func.isRequired,
    getSize: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/UploadButton.jsx